import { iaRa } from 'lib/helpers/utility';

const SKIPPED_MARKERS = ['too early', 'No matching transaction'];

/**
 * Reads the notes the backend live-check leaves on `transaction.metadata` so the UI
 * can tell an actual re-check apart from one the backend skipped.
 * @param {object} metadata - `transaction.metadata` from the recheck response
 * @returns {{ message: string, isSkipped: boolean }}
 */
export const getRecheckOutcome = (metadata) => {
  const liveCheck =
    typeof metadata?.__myriad_live_check__ === 'string' ? metadata.__myriad_live_check__ : '';

  const messages = iaRa(metadata?.log)
    .filter((entry) => typeof entry === 'string')
    .concat(liveCheck ? [liveCheck] : []);

  const isSkipped =
    liveCheck.startsWith('error') ||
    messages.some((message) => SKIPPED_MARKERS.some((marker) => message.includes(marker)));

  return { message: messages.join(' '), isSkipped };
};
